var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card border-0 rounded shadow"},[_c('div',{staticClass:"card-body"},[_c('InvoiceSettings')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }